<template>
  <div class="detail">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="专业岗位名称" v-if="type === 1">
          <el-input v-model="filter.majorName" placeholder="请输入专业岗位名称"></el-input>
        </el-form-item>
        <el-form-item label="培训班名称" v-if="type === 2">
          <el-input v-model="filter.className" placeholder="请输入培训班名称"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="filter.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="filter.idCard" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="证书编号">
          <el-input v-model="filter.certificateNumber" placeholder="请输入证书编号"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateList"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px;">
      <el-button type="primary" size="small" style="float: right;" @click="downloadAll">导出</el-button>
      <el-button type="primary" size="small" style="float: right;margin: 0 10px;" @click="downloads">下载导入模版</el-button>
      <el-button type="primary" size="small" style="float: right;" @click="$refs['img-upload-input'].click()">导入{{type === 1 ? '合格证' : '结业证'}}</el-button>
      <el-table v-if="type === 1" :data="list" border style="margin-top: 40px" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" label="姓名" prop="name" width=""></el-table-column>
        <el-table-column align="center" label="性别" prop="" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.sex === 1">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="身份证号" prop="idCard" width=""></el-table-column>
        <el-table-column align="center" label="理论知识成绩" prop="theory" width=""></el-table-column>
        <el-table-column align="center" label="操作技能考核成绩" prop="operation" width=""></el-table-column>
        <el-table-column align="center" label="综合评定成绩" prop="synthesize" width=""></el-table-column>
        <el-table-column align="center" label="学时" prop="period" width=""></el-table-column>
        <el-table-column align="center" label="证书编号" prop="certificateNumber" width=""></el-table-column>
        <el-table-column align="center" label="专业岗位名称" prop="majorName" width=""></el-table-column>
        <el-table-column align="center" label="发证日期" prop="certificateTime" width=""></el-table-column>
        <el-table-column align="center" label="发证单位" prop="certificateUnit" width=""></el-table-column>
        <el-table-column align="center" label="创建时间" prop="insertDate" width=""></el-table-column>
        <el-table-column align="center" label="操作" prop="" width="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="del(scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>

      <el-table v-if="type === 2" :data="list" border style="margin-top: 40px" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" label="姓名" prop="name" width=""></el-table-column>
        <el-table-column align="center" label="培训班名称" prop="className" width=""></el-table-column>
        <el-table-column align="center" label="开班日期" prop="openStartTime" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.openStartTime">{{ scope.row.openStartTime.split(' ')[0] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结班日期" prop="openEndTime" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.openEndTime">{{ scope.row.openEndTime.split(' ')[0] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="身份证号" prop="idCard" width=""></el-table-column>
        <el-table-column align="center" label="证书编号" prop="certificateNumber" width=""></el-table-column>
        <el-table-column align="center" label="证书内容" prop="" width="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="look(scope.row)">查看</a>
          </template>
        </el-table-column>
        <el-table-column align="center" label="发证日期" prop="certificateTime" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.certificateTime">{{ scope.row.certificateTime.split(' ')[0] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建时间" prop="insertDate" width=""></el-table-column>
        <el-table-column align="center" label="操作" prop="" width="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="del(scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      title="证书内容查看"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      {{ content }}
    </el-dialog>

    <input v-if="isShow" style="display: none" ref="img-upload-input" class="img-upload-input" type="file" accept=".xls, .xlsx" @change="submitUpload">
  </div>
</template>

<script>
import { getListPageCertificate, exportQualify, exportGraduation, importQualify, importGraduation, delOutsideCertificate } from '@/api/certificate'
import { baseURL } from '@/api/request'
export default {
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        majorName: '',
        className: '',
        name: '',
        idCard: '',
        certificateNumber: '',
        startDate: '',
        endDate: ''
      },
      type: 1,
      classifyId: '',
      list: [],
      total: 0,
      baseURL,
      isShow: true,
      selectList: [],
      dialogVisible: false,
      content: ''
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.filter.startDate, this.filter.endDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.startDate = v[0] + ' 00:00:00' || ''
          this.filter.endDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.startDate = ''
          this.filter.endDate = ''
        }
      }
    }
  },
  created() {
    this.type = +this.$route.query.type
    this.classifyId = this.$route.query.id
    this.getList()
  },
  methods: {
    async getList() {
      let res = await getListPageCertificate({...this.filter, classifyId: this.classifyId})
      if (res.code !== 0) return this.$message.error(res.message)
      this.list = res.data.records
      this.total = +res.data.total
    },
    handleSelectionChange(e) {
      this.selectList = e.map(v => v.id)
      console.log(this.selectList)
    },
    del(row) {
      this.$confirm('您确定要删除该条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delOutsideCertificate({ id: row.id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          this.getList()
          return
        }
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getList()
      }).catch(() => {});
    },
    look(row) {
      this.content = row.content
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.content = ''
    },
    // 下载模板
    downloads() {
      if (this.type === 1) {
        window.open(`${this.baseURL}/radioweb/adm/outsideCertificate/downloadQualify`)
      } else {
        window.open(`${this.baseURL}/radioweb/adm/outsideCertificate/downloadGraduation`)
      }
    },
    // 导入
    submitUpload(e) {
      const files = e.target.files
      const file = files[0] // only use files[0]
      if (!file) return
      this.upload(file)
    },
    async upload(file) {
      this.$refs['img-upload-input'].value = null
      let fd = new FormData()
      fd.append('file', file)
      fd.append('classifyId', this.classifyId)
      let res
      if (this.type === 1) {
        res = await importQualify(fd)
      } else {
        res = await importGraduation(fd)
      }
      this.download(res, '导入结果')
      this.getList()
      this.$message.success('操作完成，请检查导入结果')
    },
    // 导出
    async downloadAll() {
      const sendObj = { ...this.filter, classifyId: this.classifyId, ids: this.selectList.join() }
      delete sendObj.page
      delete sendObj.limit
      let res
      if (this.type === 1) {
        res = await exportQualify(sendObj)
      } else {
        res = await exportGraduation(sendObj)
      }
      this.download(res, this.type === 1 ? '合格证' : '结业证')
    },
    // 下载文件
    download(res, fileName) {
      let url = window.URL.createObjectURL(new Blob([res]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName + '.xls')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
      window.URL.revokeObjectURL(url) // 释放掉blob对象
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
